import toolsClient from "@/api/toolsClient"

export const getStationStreamingStats = async (params, type) => {
  const response = await toolsClient.get(`stations/stats/${type}`, { params })

  return response.data
}

export const getStationRoyaltyStats = async (params) => {
  let response = await toolsClient.get(`stations/metadata/stats/period`, {
    params: { stationKeys: params["stationKeys"], from_date: params["from_date"], to_date: params["to_date"] },
  })

  return { royalty_stats: response.data }
}

export const getAccountStreamingStats = async (accountKey, params, type) => {
  const response = await toolsClient.get(`accounts/${accountKey}/stats/${type}`, { params })

  return response.data
}

export const getAccountRoyaltyStats = async (params, accountKey) => {
  let response = await toolsClient.get(`accounts/${accountKey}/metadata/stats/period`, {
    params: { from_date: params["from_date"], to_date: params["to_date"] },
  })

  return { royalty_stats: response.data }
}

export const getAccountCTLStats = async (accountKey, params, type) => {
  const response = await toolsClient.get(`accounts/${accountKey}/stats/ctl/${type}`, { params })

  return response.data
}

export const hasAccountAppAnalytics = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/hasAppAnalytics`)

  return data.hasAppAnalytics
}

export const getAccountAppStats = async (accountKey, params, type) => {
  const response = await toolsClient.get(`accounts/${accountKey}/stats/app/${type}`, { params })

  return response.data
}

export const getStationCTLStats = async (stationKey, params, type) => {
  const response = await toolsClient.get(`stations/${stationKey}/stats/ctl/${type}`, { params })

  return response.data
}

export const getStationStreamingStatsLive = async (mountPoint, includeOutputs = false) => {
  const response = await toolsClient.get(`stations/${mountPoint}/stats/live?include_outputs=${includeOutputs}`)

  return response.data.data
}

export const getAccountStreamingStatsLive = async (accountKey) => {
  const response = await toolsClient.get(`accounts/${accountKey}/stats/live`)

  return response.data.data
}

export const getAccountCityStats = async (accountKey, countryCode, includeOutputs) => {
  const response = await toolsClient.get(
    `accounts/${accountKey}/stats/live/city?countryCode=${countryCode}&include_outputs=${includeOutputs}`
  )
  return response.data
}

export const getStationCityStats = async (mountPoint, countryCode, includeOutputs) => {
  const response = await toolsClient.get(
    `stations/${mountPoint}/stats/live/city?countryCode=${countryCode}&include_outputs=${includeOutputs}`
  )
  return response.data
}

export const getStationDetailedStats = async (stationKey, params) => {
  const response = await toolsClient.get(`stations/${stationKey}/stats/detailed`, {
    params,
    responseType: "blob",
    headers: {
      Accept: "text/csv",
    },
  })

  return {
    data: response.data,
    headers: response.headers,
  }
}

export const getStationEmailDetailedStats = async (stationKey, params) => {
  const response = await toolsClient.post(`/stations/stations/${stationKey}/stats/detailed/reports/email`, null, {
    params,
  })

  return response.data
}

export const subscribeStationArchiveRawStats = async (stationKey) => {
  const response = await toolsClient.post(`/archive/stations/${stationKey}/stats/raw/subscribe`)

  return response.data
}

export const unsubscribeStationArchiveRawStats = async (stationKey) => {
  const response = await toolsClient.post(`/archive/stations/${stationKey}/stats/raw/unsubscribe`)

  return response.data
}

export const getStationSubscriptionStatus = async (stationKey) => {
  const response = await toolsClient.get(`/archive/${stationKey}/stats/subscription/status`)

  return response.data
}

export const getStationArchiveRawStats = async (stationKey, params) => {
  const searchParams = new URLSearchParams()

  params.period.forEach((date) => {
    searchParams.append("period", date)
  })

  const response = await toolsClient.get(`/archive/stations/${stationKey}/stats/raw?${searchParams.toString()}`)

  return response.data
}
